(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_discount-code"] && !Shopify.designMode) return;
  try {
    /* Séfia — code promo "qui se déplie" : ouverture / fermeture du champ.
     L'état ouvert est gardé pendant la visite, car le panier se recharge à chaque ajout.
     Fichier groupé et chargé une fois par Shopify ; ne fait rien si le style n'est pas utilisé. */
  (function () {
    var KEY = 'sefiaDiscountOpen';

    function isStoredOpen() {
      try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
    }

    function setOpen(btn, open, focus) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('is-open', open);
      try { open ? sessionStorage.setItem(KEY, '1') : sessionStorage.removeItem(KEY); } catch (e) {}
      if (open && focus) {
        var input = panel.querySelector('input');
        if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 220);
      }
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('.cart-discount__reveal');
      if (!btn) return;
      event.preventDefault();
      setOpen(btn, btn.getAttribute('aria-expanded') !== 'true', true);
    });

    function restore(scope) {
      if (!isStoredOpen()) return;
      scope.querySelectorAll('.cart-discount__reveal[aria-expanded="false"]').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        panel.classList.add('no-transition');
        setOpen(btn, true, false);
        requestAnimationFrame(function () { panel.classList.remove('no-transition'); });
      });
    }

    /* On ne surveille que le panier (et pas toute la page) pour rouvrir le champ après un rechargement. */
    function watch(el) {
      var root = el.closest('.shopify-section') || el.parentElement;
      if (!root || root.dataset.sefiaDiscountWatch) return;
      root.dataset.sefiaDiscountWatch = 'true';
      var scheduled = false;
      restore(root);
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          restore(root);
        });
      }).observe(root, { childList: true, subtree: true });
    }

    function init() {
      document.querySelectorAll('.cart-discount-block--reveal').forEach(watch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-add-to-cart-button"] && !Shopify.designMode) return;
  try {
    (function () {

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '\u00a0€';
    }

    function updateButton(price, compareAtPrice) {
      var container = document.querySelector('[data-ref="add-to-cart-button-container"]');
      if (!container) return;
      var priceEl = container.querySelector('.button .money');
      var wrapper = container.querySelector('[data-ref="button-price-wrapper"]');
      if (!priceEl || !wrapper) return;

      if (price) priceEl.textContent = price;

      if (compareAtPrice) {
        /* Masque le prix barré natif Shopify dans le conteneur ATC */
        container.querySelectorAll('.compare-at-price').forEach(function (el) {
          el.style.display = 'none';
        });
        wrapper.textContent = compareAtPrice;
        wrapper.style.display = 'inline';
      } else {
        /* Réaffiche le prix barré natif si pas de remise bundle */
        container.querySelectorAll('.compare-at-price').forEach(function (el) {
          el.style.display = '';
        });
        wrapper.textContent = '';
        wrapper.style.display = 'none';
      }
    }

    /* ── KACHING (fallback si jamais réactivé un jour) ── */
    function hasNativeDiscount() {
      var el = document.querySelector('[data-ref="add-to-cart-button-container"]');
      return el && el.hasAttribute('data-compare-at-price');
    }

    function syncKaching() {
      if (hasNativeDiscount()) return;
      var bar     = document.querySelector('.kaching-bundles__bar--selected');
      var fullEl  = bar && bar.querySelector('.kaching-bundles__bar-full-price .money');
      var priceEl = bar && bar.querySelector('.kaching-bundles__bar-price .money');
      updateButton(
        priceEl ? priceEl.textContent.trim() : null,
        fullEl  ? fullEl.textContent.trim()  : null
      );
    }

    function initKaching(container) {
      new MutationObserver(syncKaching).observe(container, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
      syncKaching();
      setTimeout(syncKaching, 500);
      setTimeout(syncKaching, 1200);
      setTimeout(syncKaching, 2500);
    }

    /* ── MOON BUNDLES ── */
    function syncMoon(instance, offerId) {
      var prices = instance.prices.get();
      var p = prices[offerId] || prices[Object.keys(prices)[0]];
      if (!p) return;
      var discounted = p.totalDiscountedPrice;
      var original   = p.totalOriginalPrice;
      updateButton(
        formatMoney(discounted),
        original > discounted ? formatMoney(original) : null
      );
    }

    function initMoon() {
      var uuid = Object.keys(window.MoonBundle).find(function (k) {
        var inst = window.MoonBundle[k];
        return inst && typeof inst === 'object' && inst.currentOffer;
      });
      if (!uuid) return;
      var instance = window.MoonBundle[uuid];

      /* Sync initiale */
      var initial = instance.currentOffer.get();
      if (initial) syncMoon(instance, initial.id);

      /* Écoute les changements de sélection de bundle */
      instance.currentOffer.subscribe(function (offer) {
        if (!offer) return;
        syncMoon(instance, offer.id);
      });
    }

    /* ── INIT : détecte quelle app est présente sur la page ── */
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      var kaching = document.querySelector('.kaching-bundles');
      if (kaching) {
        clearInterval(poll);
        initKaching(kaching);
        return;
      }
      if (window.MoonBundle && Object.keys(window.MoonBundle).length) {
        clearInterval(poll);
        initMoon();
        return;
      }
      if (tries > 40) clearInterval(poll);
    }, 250);

    /* ── PRÉCOMMANDE : maintient la note juste après le bouton, ── */
    /* même quand Moon Bundles insère sa barre de récompenses entre les deux */
    var noteContainer = document.querySelector('[data-ref="add-to-cart-button-container"]');

    function pinPrecommandeNote() {
      if (!noteContainer) return;
      var btn  = noteContainer.querySelector('[data-ref="add-to-cart-button"]');
      var note = noteContainer.querySelector('.product-add-to-cart-button__precommande-note');
      if (btn && note && btn.nextElementSibling !== note) {
        btn.insertAdjacentElement('afterend', note);
      }
    }

    if (noteContainer && noteContainer.querySelector('.product-add-to-cart-button__precommande-note')) {
      new MutationObserver(pinPrecommandeNote).observe(noteContainer, {
        childList: true,
        subtree: true
      });
      pinPrecommandeNote();
      setTimeout(pinPrecommandeNote, 500);
      setTimeout(pinPrecommandeNote, 1200);
      setTimeout(pinPrecommandeNote, 2500);
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cross-sell"] && !Shopify.designMode) return;
  try {
    /* Séfia : si la cliente change de variante, cross-sell.js met à jour le prix du titre.
     On recopie ce prix dans le bouton "Ajouter · prix". Fichier groupé et chargé une fois par Shopify. */
  (function () {
    function sync(comp) {
      var heading = comp.querySelector('.cross-sell__heading');
      var target = comp.querySelector('.cross-sell__button-price-value');
      if (!heading || !target) return;
      var source = heading.lastElementChild;
      if (!source || source.classList.contains('cross-sell__title-and-description')) return;
      if (target.innerHTML !== source.outerHTML) target.innerHTML = source.outerHTML;
    }

    document.addEventListener('change', function (event) {
      var comp = event.target.closest && event.target.closest('cross-sell-component.cross-sell--price-in-button');
      if (!comp) return;
      setTimeout(function () { sync(comp); }, 60);
      setTimeout(function () { sync(comp); }, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
